import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed} from 'vue';

/********************************
 ********** COMPONENTS **********
 *******************************/
import HexagonMinComponent  from '@/components/principalPage/hexagonMinComponent.vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';    
import { useI18n } from 'vue-i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'IEOCardComponent',
  props: {
    width       : { type: Number, default: 300 },
    height      : { type: Number, default: 200 }
},
  setup(__props) {

const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n();



const sizeHexa      = ref(105);
const sizeTitl      = ref(35);
const sizeSubt      = ref(13);

const ieoDistri     = computed(() => store.state.ieoDistri);
const ieoAcceso     = computed(() => store.state.ieoAcceso);
const ieoClient     = computed(() => store.state.ieoClient);


return (_ctx: any,_cache: any) => {
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (ieoClient.value.length > 0)
    ? (_openBlock(), _createBlock(_component_v_sheet, {
        key: 0,
        class: "classIEOCARD my-3",
        color: "transparent",
        height: __props.height,
        width: __props.width
      }, {
        default: _withCtx(() => [
          _createVNode(HexagonMinComponent, {
            class: "HexagonPosition Hexagon2",
            title: ieoDistri.value,
            color: 'red',
            subtitle: _unref(t)('labels.online'),
            "size-hexa": sizeHexa.value,
            "size-title": sizeTitl.value,
            "size-sub-ti": sizeSubt.value
          }, null, 8, ["title", "subtitle", "size-hexa", "size-title", "size-sub-ti"]),
          _createVNode(HexagonMinComponent, {
            class: "HexagonPosition Hexagon1",
            title: ieoAcceso.value,
            color: 'red',
            subtitle: _unref(t)('labels.online'),
            "size-hexa": sizeHexa.value,
            "size-title": sizeTitl.value,
            "size-sub-ti": sizeSubt.value
          }, null, 8, ["title", "subtitle", "size-hexa", "size-title", "size-sub-ti"]),
          _createVNode(HexagonMinComponent, {
            class: "HexagonPosition Hexagon3",
            title: ieoClient.value,
            color: 'red',
            subtitle: _unref(t)('labels.online'),
            "size-hexa": sizeHexa.value,
            "size-title": sizeTitl.value,
            "size-sub-ti": sizeSubt.value
          }, null, 8, ["title", "subtitle", "size-hexa", "size-title", "size-sub-ti"]),
          _createVNode(_component_v_sheet, { class: "cardTitleIEO IEO1" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('labels.distribution')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_sheet, { class: "cardTitleIEO IEO2" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('labels.access')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_sheet, { class: "cardTitleIEO IEO3" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('labels.client')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["height", "width"]))
    : _createCommentVNode("", true)
}
}

})